/**
 *
 *  Filename........: register.js
 *  Project.........: logistik.app
 *  @copyright......: YBM Deutschland Andy Puderbach und Stephan Wienczny GBR
 *  @link...........: https://www.ybm-deutschland.de/
 *  @version........: 1.0
 *
 *  @since..........: 23.11.20, 12:59
 *  @author.........: Alexander Helmich
 *
 *  @brief..........:
 *
 */
import Vue from 'vue';

const files = require.context('./', true, /\.vue$/i);

files.keys().map(key => {
    const name = _.last(key.split('/')).split('.')[0];
    return Vue.component(name, files(key).default)
});

import Locales from './i18n/vue-i18n-locales.generated';

Vue.i18n.add('de', Locales.de);

